import React from "react";
import { Container, Row, Col } from "react-bootstrap";
// import homeLogo from "../../Assets/home-main.svg";
import homeLogo from "../../Assets/WFH.png";
import homeLogo2 from "../../Assets/Untitled.svg"
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import '../Home/Home.css'

function Home() {
  return (
    <section>
      <Container fluid className="home-section vh-100" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header " >
              <h1 style={{ paddingBottom: 15 }} className="heading-name"  >
                Hey, There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1
                className="heading-name"
              >
                I'M
                <strong className="main-name"> AKHIL JP</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>
            <Col md={5} style={{ paddingBottom: 20 }}
            //  className="mt-5 HomeLogo animate__animated animate__fadeInRight animate__delay-1s"
            >
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid wfhExample"
                style={{ maxHeight: "480px" }}
              />
            </Col>
            
          </Row>
        </Container>
      </Container>
      <Home2 />
      {/* <section class="call-buton"><a class="cc-calto-action-ripple" href="tel:918921093869"><i class="fa fa-phone"></i><span class="num"></span>
      </a>
      </section> */}
    </section>
  );
}

export default Home;
